import WalletBaseStat from "./WalletBaseStat";

export default WalletBaseStat;